// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ks-1";
export var messageSideRight = "_ks-2";
export var subscribeToBackInStockBubbleContainer = "_ks-0";